"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = _interopRequireDefault(require("./inline_svg.proptypes"));

var _inline_svg2 = require("./inline_svg.utils");

var _excluded = ["fontsize", "themeColor"];

var InfantIcon = function InfantIcon(props) {
  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var _parseStyles = (0, _inline_svg2.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, sizeStyles, {
    fill: "none"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M20.3333 7.77212C20.3333 9.2037 19.1615 10.375 17.7292 10.375C16.2969 10.375 15.125 9.2037 15.125 7.77212C15.125 6.34054 16.2969 5.16924 17.7292 5.16924C19.1615 5.10417 20.3333 6.27546 20.3333 7.77212Z"
  }, colorStyles)), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    d: "M17.1416 15.8884L16.0698 12.7599C16.0698 12.6854 15.9932 12.6109 15.9932 12.5364L15.0745 10.1527C14.6917 9.40783 13.5432 9.33334 13.5432 9.33334H8.1839C3.43706 11.0466 7.03547 14.7711 7.03547 14.7711H5.04486C4.27924 14.7711 3.66675 15.367 3.66675 16.1119C3.66675 16.8568 4.27924 17.4527 5.04486 17.4527H8.49015C8.56671 17.4527 8.56671 17.4527 8.64327 17.4527C8.71983 17.4527 8.71983 17.4527 8.79639 17.4527C9.56201 17.4527 10.1745 16.8568 10.1745 16.1119V14.9946C10.1745 14.6966 10.4808 14.7711 10.4808 14.7711H13.8495L14.5385 16.7823C14.7682 17.4527 15.5338 17.8252 16.2995 17.6017C16.9885 17.3038 17.3713 16.5589 17.1416 15.8884Z"
  }, colorStyles)));
};

InfantIcon.propTypes = _inline_svg.default.propTypes;
InfantIcon.defaultProps = _inline_svg.default.defaultProps;
var _default = InfantIcon;
exports.default = _default;